import React, {useId} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, useBreakpointValue} from '@chakra-ui/react3'
import StackableImage from '../../../leap/components/stackable-image'

const ENGRAVING_LAYOUTS = {
    gallery: {
        mobile: {curveY: 110, textTop: '28.5%'},
        expanded: {curveY: 32, textTop: '47.3%'},
        tablet: {curveY: 40, textTop: '43.7%'},
        desktop: {curveY: 10, textTop: '46.3%'},
        large: {curveY: -5, textTop: '46.3%'}
    },
    overlay: {
        mobile: {curveY: 40, textTop: '43.7%'},
        desktop: {curveY: 60, textTop: '41.5%'}
    }
}

const EngravingStackableImage = ({
    alt,
    images,
    engraveText,
    isExpanded = false,
    isEngravingOverlay = false,
    ...rest
}) => {
    const engravingPathId = useId()
    const {formatMessage} = useIntl()

    const {textTop, curveY} = useBreakpointValue(
        isEngravingOverlay
            ? {base: ENGRAVING_LAYOUTS.overlay.mobile, s: ENGRAVING_LAYOUTS.overlay.desktop}
            : {
                  base: isExpanded
                      ? ENGRAVING_LAYOUTS.gallery.expanded
                      : ENGRAVING_LAYOUTS.gallery.mobile,
                  xs: ENGRAVING_LAYOUTS.gallery.tablet,
                  s: ENGRAVING_LAYOUTS.gallery.desktop,
                  l: ENGRAVING_LAYOUTS.gallery.large
              }
    )

    const updatedAlt = engraveText
        ? formatMessage(
              {
                  id: 'configurator.step.engraving.aria-label',
                  defaultMessage: '{alt} - Engraving: {engraveText}'
              },
              {alt, engraveText}
          )
        : alt

    return (
        <StackableImage
            images={images}
            alt={updatedAlt}
            {...rest}
            tabIndex={-1}
            // used by the engraving text layer style
            containerType="size"
        >
            {engraveText && (
                <Box
                    aria-hidden="true"
                    layerStyle="engraving.text"
                    css={{'--engraving-text-top': textTop}}
                    zIndex={10}
                >
                    <svg width="1" height="1" overflow="visible" focusable="false">
                        {/* Defines the arc followed by the engraving text. */}
                        <defs>
                            <path id={engravingPathId} d={`M -200 -32 Q 0 ${curveY} 200 -32`} />
                        </defs>
                        <text fill="currentColor">
                            <textPath
                                href={`#${engravingPathId}`}
                                startOffset="50%"
                                textAnchor="middle"
                            >
                                {engraveText}
                            </textPath>
                        </text>
                    </svg>
                </Box>
            )}
        </StackableImage>
    )
}

EngravingStackableImage.propTypes = {
    alt: PropTypes.string,
    images: PropTypes.array,
    product: PropTypes.object,
    engraveText: PropTypes.string,
    isExpanded: PropTypes.bool,
    isEngravingOverlay: PropTypes.bool,
    widths: PropTypes.object
}

export default EngravingStackableImage
